import React from "react";
import StageHeader from "./StageHeader";

import { CommandBlock } from "../common/Commands2";

export default function InvoiceExportStage({
  system,
  period,
  stage,
  stageIndex,
}) {
  const extraFields = [
    {
      label: "Invoice No",
      render(command) {
        return command.state.exportedInvoiceNumber || "-";
      },
    },
  ];

  return (
    <>
      <StageHeader stageIndex={stageIndex} stage={stage} />
      <CommandBlock
        endpoint={`/bill/${system}/${period}/${stage.stage}/invoice-export-commands`}
        enabled
        schedule
        summarize
        extraFields={extraFields}
      />
    </>
  );
}
